import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["children"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { optimizeLegibility } from '@flowio/react-theme';
import React from 'react';
var rootStyles = /*#__PURE__*/css(_objectSpread(_objectSpread({}, optimizeLegibility()), {}, {
  display: 'block',
  paddingTop: '4px',
  boxSizing: 'border-box',
  color: '#4d5866',
  fontSize: '0.75rem'
}), process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hpbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCbUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvSGludC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cblxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBvcHRpbWl6ZUxlZ2liaWxpdHkgfSBmcm9tICdAZmxvd2lvL3JlYWN0LXRoZW1lJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbnR5cGUgT3duUHJvcHMgPSB7XG4gIGNoaWxkcmVuPzogUmVhY3QuUmVhY3ROb2RlO1xufTtcblxudHlwZSBVbmhhbmRsZWRQcm9wcyA9IE9taXQ8XG4gIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50PixcbiAga2V5b2YgT3duUHJvcHNcbj47XG5cbnR5cGUgUHJvcHMgPSBPd25Qcm9wcyAmIFVuaGFuZGxlZFByb3BzO1xuXG5jb25zdCByb290U3R5bGVzID0gY3NzKHtcbiAgLi4ub3B0aW1pemVMZWdpYmlsaXR5KCksXG4gIGRpc3BsYXk6ICdibG9jaycsXG4gIHBhZGRpbmdUb3A6ICc0cHgnLFxuICBib3hTaXppbmc6ICdib3JkZXItYm94JyxcbiAgY29sb3I6ICcjNGQ1ODY2JyxcbiAgZm9udFNpemU6ICcwLjc1cmVtJyxcbn0pO1xuXG5jb25zdCBIaW50OiBSZWFjdC5GQzxQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPGRpdiB7Li4udW5oYW5kbGVkUHJvcHN9IGNzcz17cm9vdFN0eWxlc30+XG4gICAge2NoaWxkcmVufVxuICA8L2Rpdj5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IEhpbnQ7XG4iXX0= */");

var Hint = function Hint(_ref) {
  var children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("div", _extends({}, unhandledProps, {
    css: rootStyles
  }), children);
};

export default Hint;